import service from '../../utils/service'
import Urls from '../../utils/urlStrings'
import { MICROSERVICES } from '../../utils/constants'

export class UserPreferenceService {
  async setPreference(account_id, program_id, screen_name, payload) {
    try {
      const response = await service.put(Urls.getApiUrl(`admin/${account_id}/userpreferences/${program_id}/${screen_name}`, MICROSERVICES.SESSIONMANAGER), payload)
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }
}

export const userPreferenceService = new UserPreferenceService()
